//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// nivo components grafico pizza
import { Pie } from "@nivo/pie";
import { ThemeProvider, SvgWrapper } from "@nivo/core";
import { BoxLegendSvg } from "@nivo/legends";
import PieChart from "@material-ui/icons/PieChart";


// @material-ui/icons
import Check from "@material-ui/icons/Check";
import Icon from "@material-ui/core/Icon";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import CardFooter from "beaktShared/components/Card/CardFooter.js";
import RegistrarContatoList from "./RegistrarContatoList";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

// styles
import styles2 from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function ResultadoCampanha({ itemcampanha, handleViewResultado }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const classes2 = useStyles2();
    const { register, handleSubmit, getValues} = useForm({ mode: "onChange" });
    const session = useContext(SessionContext);

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 4000);
    };

    const endPoint = "campanhas/";

    const chartTiposContato = [
        {
            id: t('label.correio_eletronic')+ " %",
            label: t('label.correio_eletronic') + " %",
            value: itemcampanha.totalCorreioEletronico,
            color:"rgb(0, 0, 0)"
        },
        {
            id: t('label.email') + " %",
            label: t('label.email')+ " %",
            value: itemcampanha.totalEmail,
            color: "rgb(29, 111, 168)"
        },
        {
            id: t('label.whatsApp') + " %",
            label: t('label.whatsApp') + " %",
            value: itemcampanha.totalWhats,
            color: "rgb(255, 127, 14)"
        },
        {
            id: t('label.social_network') + " %",
            label: t('label.social_network') + " %",
            value: itemcampanha.totalRedeSocial,
            color: "rgb(41, 149, 41)"
        },
        {
            id: t('label.telephone') + " %",
            label: t('label.telephone') + " %",
            value: itemcampanha.totalTelefone,
            color: "rgb(165, 83, 37)"
        },
        {
            id: t('label.letter') + " %",
            label: t('label.letter') + " %",
            value: itemcampanha.totalCarta,
            color: "rgb(236, 255, 47)"
        }

    ];
    const [btnRegistroContato, setbtnRegistroContato] = React.useState(false);

    //Registrar Contatos
    const [labelTitle, setlabelTitle] = React.useState(t('label.view_customers_contacts'));
    const [clientesContatocampanha, setclientesContatocampanha] = React.useState([]);
    const handleListClientesContato = id => {
        let endPointGetCampanha = endPoint + "clientescontatobycampanha/" + itemcampanha.campanhaId;

        UseGetApiSimple(endPointGetCampanha, 0).then(result => {
            if (result.status !== 200) {
                handleViewClientesContato(false);
                return false;
            }
            setbtnRegistroContato(false);
            setclientesContatocampanha(result.data);
            handleViewClientesContato(false);
            return true;
        });
    }

    const [showFormViewContato, setshowFormViewContato] = React.useState(false);
    const handleViewClientesContato = () => {
        let show = showFormViewContato === true ? false : true;
        let title = showFormViewContato == true ? t('label.view_customers_contacts') : t('label.graphic')
       
        setlabelTitle(title);
        setshowFormViewContato(show);
    };

    const handleCancelar = () => {
        handleViewResultado(false)
    }
    return (

        <div>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                close
            />

            <GridContainer className={classes2.center}>
                <GridItem xs={12} sm={6} md={6} lg={4}>
                    <Card>
                        <CardHeader color="warning" stats icon>
                            <CardIcon color="warning">
                                <Icon>bookmarks</Icon>
                            </CardIcon>
                            <p className={classes.cardCategory}>{t('label.total_clientes')}</p>
                            <h3 className={classes.cardTitle}>
                                {itemcampanha.totalContatos}
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats}>
                                <a href="#pablo" onClick={() => handleListClientesContato(itemcampanha.campanhaId)}>
                                    {labelTitle}
                                </a>
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={4}>
                    <Card>
                        <CardHeader color="warning" stats icon>
                            <CardIcon color="info">
                                <Icon>hourglass_empty</Icon>
                            </CardIcon>
                            <p className={classes.cardCategory}>{t('label.uncontacted_customers')}</p>
                            <h3 className={classes.cardTitle}>
                                {itemcampanha.contatosPendentes}
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats}><br></br></div>
                        </CardFooter>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={4}>
                    <Card>
                        <CardHeader color="warning" stats icon>
                            <CardIcon color="success">
                                <Check />
                            </CardIcon>
                            <p className={classes.cardCategory}>{t('label.contacts_made')}</p>
                            <h3 className={classes.cardTitle}>
                                {itemcampanha.contatosRealizados}
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats}><br></br></div>
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
            {showFormViewContato && <RegistrarContatoList itemcampanha={clientesContatocampanha} handleViewContato={handleViewClientesContato} btnRegistraContato={btnRegistroContato} />}

            {!showFormViewContato &&
                <GridContainer>
                    <GridItem lg={12} sm={12}>
                        <center>
                            <Card className={classes2.center} style={{ minHeight: '565px' }}>
                                <CardHeader color="primary" icon>
                                    <CardIcon color="primary">
                                        <PieChart />
                                    </CardIcon>
                                    <h3 className={classes.cardIconTitle}>{t('information_message.number_of_contacts_made')} (%)</h3>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={2} md={2} lg={2}>
                                            <ThemeProvider>
                                                <SvgWrapper height={105} margin={{ left: 5, right: 10, top: 0, bottom: 0 }}>
                                                    <BoxLegendSvg
                                                        anchor="right"
                                                        data={chartTiposContato}
                                                        direction="column"
                                                        itemWidth={120}
                                                        itemHeight={18}
                                                        //itemOpacity={.5}
                                                        symbolSize={12}
                                                        symbolShape="square"
                                                        colors={(chartTiposContato) => chartTiposContato.color }

                                                    />
                                                </SvgWrapper>
                                            </ThemeProvider>
                                        </GridItem>
                                        <GridItem xs={12} sm={8} md={8} lg={8}>
                                            <Pie
                                                width={525}
                                                height={525}
                                                data={chartTiposContato}
                                                margin={{ left: 100, right: 100 }}
                                                startAngle={-65}
                                                endAngle={360}
                                                innerRadius={0.5}
                                                padAngle={0.7}
                                                cornerRadius={3}
                                                colors={(chartTiposContato) => chartTiposContato.color }
                                                borderWidth={1}
                                                borderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
                                                radialLabelsSkipAngle={1}
                                                radialLabelsTextColor="#333333"
                                                radialLabelsLinkColor={{ from: 'color' }}
                                                sliceLabelsSkipAngle={10}
                                                slicesLabelsTextColor="#000"
                                                radialLabelsLinkOffset={-10}
                                                radialLabelsLinkDiagonalLength={20}
                                                radialLabelsLinkHorizontalLength={10}
                                                radialLabelsLinkStrokeWidth={2}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </center>
                    </GridItem>
                </GridContainer>
            }

            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <center>
                        <Button onClick={() => handleCancelar()} color="transparent" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                    </center>
                </GridItem>
            </GridContainer>
        </div>
    );
}